import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { login, signIn } from "./authCrud";

const initialState = {
  user: undefined,
  status: "idle",
  errMessage: null,
};

const tokenExpireTimeSetter = (data) => {
  const today = new Date();
  const tomorrow = today.setDate(today.getDate() + 1);
  localStorage.setItem(
    "userInfo",
    JSON.stringify({
      token: data?.token,
      expire: tomorrow,
    })
  );
};

export const loginAct = createAsyncThunk("auth/login", async (params) => {
  const response = await login(params);

  tokenExpireTimeSetter(response?.data);

  return response?.data.user;
});

export const signInAct = createAsyncThunk("auth/signin", async (params) => {
  const response = await signIn(params);

  tokenExpireTimeSetter(response?.data);
  return response?.data.user;
});

export const setUser = createAction("auth/setUser", (dataPayload) => {
  return {payload:dataPayload};
});

export const auth = createSlice({
  name: "auth",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(loginAct.pending, (state) => {
        state.status = "pending";
      })
      .addCase(loginAct.fulfilled, (state, action) => {
        state.status = "loggenIn";
        state.user = action.payload;
        state.errMessage = null;
      })
      .addCase(loginAct.rejected, (state) => {
        state.status = "failed";
        state.errMessage = "نام کاربری و رمزعبور نادرست میباشد";
      });

    builder
      .addCase(signInAct.pending, (state) => {
        state.status = "loading";
      })
      .addCase(signInAct.fulfilled, (state, action) => {
        state.status = "loggenIn";
        state.errMessage = null;
        state.user = action.payload;
      })
      .addCase(signInAct.rejected, (state) => {
        state.errMessage = "اطلاعات وارد شده نادرست است";
        state.status = "failed";
      });

    builder.addCase(setUser, (state, action) => {
      state.user = action.payload;
    });
  },
});

export const selectauthList = (state) => state.auth;

export default auth.reducer;
